import { inject, Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { NotificationService } from './notification.service';

const POLL_INTERVAL_MS = 5 * 60 * 1000;

interface VersionJson {
  version?: string;
}

@Injectable({
  providedIn: 'root',
})
export class VersionCheckService {
  private readonly notificationService = inject(NotificationService);
  private readonly currentVersion = environment.version;
  private notifiedVersion: string | null = null;
  private intervalId: ReturnType<typeof setInterval> | null = null;
  private started = false;

  start(): void {
    if (this.started) {
      return;
    }
    this.started = true;

    void this.checkNow();

    this.intervalId = setInterval(() => {
      void this.checkNow();
    }, POLL_INTERVAL_MS);

    if (typeof document !== 'undefined') {
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
          void this.checkNow();
        }
      });
    }
  }

  async checkNow(): Promise<void> {
    try {
      const response = await fetch('/version.json', { cache: 'no-store' });
      if (!response.ok) {
        return;
      }

      const data = (await response.json()) as VersionJson;
      const serverVersion = data.version;
      if (
        !serverVersion ||
        serverVersion === this.currentVersion ||
        serverVersion === this.notifiedVersion
      ) {
        return;
      }

      this.notifiedVersion = serverVersion;
      this.notificationService.showAction(
        'common.update-available',
        'common.reload',
        () => {
          globalThis.location?.reload();
        }
      );
    } catch {
      /* ignore network / parse errors */
    }
  }
}
